import {PageType} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";

/**
 * Map a config `page.type` UUID to the PageType enum key (e.g. DashBoard, AgentHomePage).
 * Falls back to the raw UUID when the type is unknown.
 */
export function argusPageTypeName(pageType: string): string {
    const matchingEntry = (Object.entries(PageType) as Array<[string, string]>).find(([, value]) => {
        return value === pageType;
    });
    if (matchingEntry === undefined) {
        return pageType;
    }
    return matchingEntry[0];
}
